var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Questions_Icon",
    "data-name": "Questions Icon",
    transform: "translate(-17.969 -18.026)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(18.719 18.776)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M63.558,33.915a15,15,0,0,1,10.281,3.537,11.512,11.512,0,0,1,4.019,9.04,14.272,14.272,0,0,1-.6,4.224,10.487,10.487,0,0,1-1.556,3.2,17.367,17.367,0,0,1-2.11,2.343,21.866,21.866,0,0,1-2.315,1.88q-1.167.816-2.124,1.57A6.9,6.9,0,0,0,67.6,61.4a3.617,3.617,0,0,0-.6,1.981H58.619a12.944,12.944,0,0,1,.554-3.9,8.741,8.741,0,0,1,1.456-2.868,15.5,15.5,0,0,1,1.981-2.052,24.647,24.647,0,0,1,2.157-1.675c.716-.5,1.379-.993,1.981-1.5A6.188,6.188,0,0,0,68.2,49.622a4.844,4.844,0,0,0-.959-5.766,5.767,5.767,0,0,0-3.99-1.355,5.905,5.905,0,0,0-4.529,1.861,6.855,6.855,0,0,0-1.733,4.863L48.4,48.352a14.21,14.21,0,0,1,4.4-10.367A14.943,14.943,0,0,1,63.568,33.91ZM63,76.836a5.358,5.358,0,0,1-3.89-1.556,5.121,5.121,0,0,1-1.589-3.8,5.022,5.022,0,0,1,1.589-3.771A5.384,5.384,0,0,1,63,66.184a5.292,5.292,0,0,1,3.856,1.542,5.042,5.042,0,0,1,1.589,3.756,5.144,5.144,0,0,1-1.589,3.8A5.293,5.293,0,0,1,63,76.836Z",
    transform: "translate(-12.609 -4.815)",
    fill: "#a5551c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestions);
export default __webpack_public_path__ + "static/media/Questions.16fe2f7f62ebeab32ff37d2a8890cfa6.svg";
export { ForwardRef as ReactComponent };